/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { JsonNode } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Any authenticated role**
 */
export const getClientSettings = (
  userId: string,
  clientId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<JsonNode>(
    {
      url: `/api/${userId}/clients/${clientId}/settings`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetClientSettingsQueryKey = (
  userId: string,
  clientId: number
) => {
  return [`/api/${userId}/clients/${clientId}/settings`] as const;
};

export const getGetClientSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientSettings>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClientSettingsQueryKey(userId, clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientSettings>>
  > = ({ signal }) =>
    getClientSettings(userId, clientId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && clientId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientSettings>>
>;
export type GetClientSettingsQueryError = ErrorType<unknown>;

export function useGetClientSettings<
  TData = Awaited<ReturnType<typeof getClientSettings>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientSettings>>,
          TError,
          Awaited<ReturnType<typeof getClientSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientSettings<
  TData = Awaited<ReturnType<typeof getClientSettings>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientSettings>>,
          TError,
          Awaited<ReturnType<typeof getClientSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientSettings<
  TData = Awaited<ReturnType<typeof getClientSettings>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientSettings<
  TData = Awaited<ReturnType<typeof getClientSettings>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  clientId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientSettingsQueryOptions(
    userId,
    clientId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const updateClientSettings = (
  userId: string,
  clientId: number,
  jsonNode: BodyType<JsonNode>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<JsonNode>(
    {
      url: `/api/${userId}/clients/${clientId}/settings`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: jsonNode,
      signal,
    },
    options
  );
};

export const getUpdateClientSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClientSettings>>,
    TError,
    { userId: string; clientId: number; data: BodyType<JsonNode> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClientSettings>>,
  TError,
  { userId: string; clientId: number; data: BodyType<JsonNode> },
  TContext
> => {
  const mutationKey = ['updateClientSettings'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClientSettings>>,
    { userId: string; clientId: number; data: BodyType<JsonNode> }
  > = (props) => {
    const { userId, clientId, data } = props ?? {};

    return updateClientSettings(userId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClientSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClientSettings>>
>;
export type UpdateClientSettingsMutationBody = BodyType<JsonNode>;
export type UpdateClientSettingsMutationError = ErrorType<unknown>;

export const useUpdateClientSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateClientSettings>>,
      TError,
      { userId: string; clientId: number; data: BodyType<JsonNode> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateClientSettings>>,
  TError,
  { userId: string; clientId: number; data: BodyType<JsonNode> },
  TContext
> => {
  return useMutation(
    getUpdateClientSettingsMutationOptions(options),
    queryClient
  );
};
